/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Locale } from "@cosmos/hygraph-schema/dist/generated/resolvers.hygraph";

/**
 * All of the 32 locale options
 */
export const legalLocaleOptions = [
	{
		id: "clmtf5rs401ax0amvyjs1pjnr",
		label: "English",
		langCode: "en-US",
		locale: Locale.En,
	},
	{
		id: "clmzis6rs15g60bofgs64cntz",
		label: "العربية",
		langCode: "ar",
		locale: Locale.En,
	},
	{
		id: "clmziu95m15h40boflxfli7kg",
		label: "Deutsch",
		langCode: "de",
		locale: Locale.En,
	},
	{
		id: "clmziwz5s15ve0an60uyd5bxb",
		label: "Español",
		langCode: "es-ES",
		locale: Locale.En,
	},
	{
		id: "clmzizq4r15w20bofcmjhi9gu",
		label: "Español (LA)",
		langCode: "es-MX",
		locale: Locale.En,
	},
	{
		id: "clmzj1geu161m0bofwih2j323",
		label: "Français",
		langCode: "fr",
		locale: Locale.En,
	},
	{
		id: "clmzj2mua16aw0an68t2hy3zd",
		label: "Italiano",
		langCode: "it",
		locale: Locale.En,
	},
	{
		id: "clmzj3mxw163k0bofj0aezis7",
		label: "日本語",
		langCode: "ja",
		locale: Locale.En,
	},
	{
		id: "clmzj5cf8164l0bofrek0hxdh",
		label: "한국어",
		langCode: "ko",
		locale: Locale.En,
	},
	{
		id: "clmzj6ueg16f10an6tl4a9anu",
		label: "Polski",
		langCode: "pl",
		locale: Locale.En,
	},
	{
		id: "clmzjbmj716o80an69ltz5n3k",
		label: "Português (Brasil)",
		langCode: "pt-BR",
		locale: Locale.En,
	},
	{
		id: "clmzjcwr016qf0an69ejrra7v",
		label: "Русский",
		langCode: "ru",
		locale: Locale.En,
	},
	{
		id: "clmzjdxwr16hc0boffs89yhbe",
		label: "ไทย",
		langCode: "th",
		locale: Locale.En,
	},
	{
		id: "clmzjgy0916sw0an6yuo5bdc9",
		label: "Türkçe",
		langCode: "tr",
		locale: Locale.En,
	},
	{
		id: "clmzjizv517280an69jkfg580",
		label: "简体中文",
		langCode: "zh-CN",
		locale: Locale.En,
	},
	{
		id: "clmzjm0xb17ay0an6bj1wfhum",
		label: "繁體中文",
		langCode: "zh-Hant",
		locale: Locale.En,
	},
	{
		id: "clsezd8ib5nth0aoiaqawqc2p",
		label: "Svenska",
		langCode: "sv",
		locale: Locale.En,
	},
	{
		id: "cm5px42k813f406oh2bt26az9",
		label: "Български",
		langCode: "bg",
		locale: Locale.En,
	},
	{
		id: "cm5v5e9uu55rd07ocpoxjwed5",
		label: "Čeština",
		langCode: "cs",
		locale: Locale.En,
	},
	{
		id: "cm5v5eir854sr07ocjuwyxug6",
		label: "Dansk",
		langCode: "da",
		locale: Locale.En,
	},
	{
		id: "cm5v5err755rz07octqkvj1m0",
		label: "Nederlands",
		langCode: "nl",
		locale: Locale.En,
	},
	{
		id: "cm5v5kztd56gx07ocsel5tcey",
		label: "Filipino",
		langCode: "fil",
		locale: Locale.En,
	},
	{
		id: "cm5v5lbl455l407oc2c9faqi6",
		label: "Suomi",
		langCode: "fi",
		locale: Locale.En,
	},
	{
		id: "cm5v5qojt55y207ocub7q9gdn",
		label: "हिन्दी",
		langCode: "hi",
		locale: Locale.En,
	},
	{
		id: "cm5v5qxf2572007oc1nj751s9",
		label: "Magyar",
		langCode: "hu",
		locale: Locale.En,
	},
	{
		id: "cm5v5r58x55z007ocfogjwshv",
		label: "Bahasa Indonesia",
		langCode: "id",
		locale: Locale.En,
	},
	{
		id: "cm5v5rcly573607ocfohj7ee9",
		label: "Bahasa Melayu",
		langCode: "ms",
		locale: Locale.En,
	},
	{
		id: "cm5v5rke5573d07ocuow5j4f2",
		label: "Norsk",
		langCode: "no",
		locale: Locale.En,
	},
	{
		id: "cm5v5rro0561f07ocfg06xwkz",
		label: "Português Europeu",
		langCode: "pt",
		locale: Locale.En,
	},
	{
		id: "cm5v5ryf1575007oc8fqsurod",
		label: "Română",
		langCode: "ro",
		locale: Locale.En,
	},
	{
		id: "cm5v5sc6c563707oczgnh7s6n",
		label: "Українська",
		langCode: "uk",
		locale: Locale.En,
	},
	{
		id: "cm5v5shwn576a07ocu3dtbs3l",
		label: "Tiếng Việt",
		langCode: "vi",
		locale: Locale.En,
	},
];
